import { Link } from "@/components/common/Link";
export default function QuoteHero() {
  return <section id="quoterequesthero" data-nav="light" className="w-full bg-background border-b border-border/40 py-12 md:py-16">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center">
          <h1 className="font-default font-semibold tracking-tight text-foreground !text-6xl">Offertförfrågan badrumsrenovering i Värmland</h1>
          <p className="font-default text-lg text-muted-foreground md:text-xl mt-4 leading-relaxed">Planerar du en badrumsrenovering i Karlstad, Arvika eller någon annan del av Värmland? Skicka din offertförfrågan till Proffsbadrum via formuläret nedan. Vi återkommer personligen med ett tydligt underlag och hjälper dig vidare med rådgivning, kostnadsfritt hembesök och fast pris.</p>
        </div>
      </div>
    </section>;
}